// import { Row, Col, Card, Form, Button } from "react-bootstrap";
// import { useEffect, useState } from "react";
// import api from "app/services/api";

// export default function General({ employee }) {
//   //  Dropdown arrays

//   const roles = ["Admin", "User", "Manager"];
//   const [departments, setDepartments] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [shifts, setShifts] = useState([]);
//   const statuse = ["Active", "Inactive", "Terminated"];
//   const attendanceTypes = ["In-Office", "Remote", "Hybrid"];

//   // Local state for editable form
//   const [formData, setFormData] = useState({
//     firstName: employee.firstName || "",
//     lastName: employee.lastName || "",
//     staffId: employee.staffId || "",
//     username: employee.username || "",
//     email: employee.email || "",
//     phone: employee.phone || "",
//     address: employee.address || "",
//     city: employee.city || "",
//     state: employee.state || "",
//     zip: employee.zip || "",
//     country: employee.country || "",
//     dob: employee.dob || "",
//     gender: employee.gender || "",
//     maritalstatus: employee.maritalstatus || "",
//     company: employee.company || "",
//     department: employee.department || "",
//     designation: employee.designation || "",
//     role: employee.role || "",
//     status: employee.status || "",
//     officeShift: employee.officeShift || "",
//     dateOfJoining: employee.doj || "",
//     dateOfLeaving: employee.dol || "",
//     attendanceType: employee.attendanceType || "",
//   });

//   const fetchCompanies = async () => {
//     const res = await api.get("/api/company/all");
//     setCompanies(res.data.data || []);
//   };

//   const fetchDepartments = async (companyId) => {
//     if (!companyId) return;
//     const res = await api.get(`/api/departments/all?company_id=${companyId}`);
//     setDepartments(res.data.data || []);
//   };

//   const fetchDesignations = async (companyId, departmentId) => {
//     if (!companyId || !departmentId) return;
//     const res = await api.get(
//       `/api/designations/all?company_id=${companyId}&department_id=${departmentId}`,
//     );
//     setDesignations(res.data.data || []);
//   };

//   const fetchShifts = async (companyId) => {
//     if (!companyId) return;
//     const res = await api.get(`/api/shifts/all?company_id=${companyId}`);
//     setShifts(res.data.data || []);
//   };

//   useEffect(() => {
//     if (!employee) return;

//     // 🔥 form autofill
//     setFormData((prev) => ({
//       ...prev,
//       firstName: employee.first_name || "",
//       lastName: employee.last_name || "",
//       staffId: employee.staff_id || "",
//       username: employee.username || "",
//       email: employee.email || "",
//       phone: employee.contact_no || "",
//       address: employee.address || "",
//       city: employee.city || "",
//       state: employee.state || "",
//       zip: employee.zip_code || "",
//       country: employee.country || "",
//       dob: employee.date_of_birth?.split("T")[0] || "",
//       gender: employee.gender || "",
//       maritalstatus: employee.marital_status || "",
//       company: employee.company_id || "", // 🔥 ID important
//       department: employee.department_id || "",
//       designation: employee.designation_id || "",
//       role: employee.role_users_id || "",
//       officeShift: employee.office_shift_id || "",
//       dateOfJoining: employee.joining_date?.split("T")[0] || "",
//       dateOfLeaving: employee.exit_date?.split("T")[0] || "",
//       attendanceType: employee.attendance_type || "",
//     }));

//     // 🔥 load dropdowns
//     fetchCompanies();
//     fetchDepartments(employee.company_id);
//     fetchDesignations(employee.company_id, employee.department_id);
//     fetchShifts(employee.company_id);
//   }, [employee]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     // 🔥 cascading dropdowns
//     if (name === "company") {
//       fetchDepartments(value);
//       setDesignations([]);
//     }

//     if (name === "department") {
//       fetchDesignations(formData.company, value);
//     }
//   };
//   const handleSave = () => {
//     console.log("Saved Data:", formData);
//     alert("Employee data saved successfully!");
//     // TODO: API call to save data
//   };

//   return (
//     <Row>
//       <Col md={12}>
//         <Card body>
//           <h5 className="mb-3">Basic Information</h5>

//           {/* Name & Staff ID */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>First Name</Form.Label>
//               <Form.Control
//                 name="firstName"
//                 value={formData.firstName}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>Last Name</Form.Label>
//               <Form.Control
//                 name="lastName"
//                 value={formData.lastName}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>Staff ID</Form.Label>
//               <Form.Control
//                 name="staffId"
//                 value={formData.staffId}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           {/* Username, Email, Phone */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Username</Form.Label>
//               <Form.Control
//                 name="username"
//                 value={formData.username}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>Phone</Form.Label>
//               <Form.Control
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           {/* Address, City, State */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Address</Form.Label>
//               <Form.Control
//                 name="address"
//                 value={formData.address}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>City</Form.Label>
//               <Form.Control
//                 name="city"
//                 value={formData.city}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>State / Province</Form.Label>
//               <Form.Control
//                 name="state"
//                 value={formData.state}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           {/* Zip, Country, DOB */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Zip</Form.Label>
//               <Form.Control
//                 name="zip"
//                 value={formData.zip}
//                 onChange={handleChange}
//               />
//             </Col>
//             <Col md={4}>
//               <Form.Label>Country</Form.Label>
//               <Form.Select
//                 name="country"
//                 value={formData.country}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Country</option>
//                 <option value="India">India</option>
//                 <option value="United States">United States</option>
//                 <option value="United Kingdom">United Kingdom</option>
//                 <option value="Canada">Canada</option>
//                 <option value="Australia">Australia</option>
//               </Form.Select>
//             </Col>
//             <Col md={4}>
//               <Form.Label>Date Of Birth</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dob"
//                 value={formData.dob}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           {/* Gender, Marital Status, Company */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Gender</Form.Label>
//               <Form.Select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Gender</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </Form.Select>
//             </Col>
//             <Col md={4}>
//               <Form.Label>Marital Status</Form.Label>
//               <Form.Select
//                 name="maritalstatus"
//                 value={formData.maritalstatus}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Marital Status</option>
//                 <option value="Single">Single</option>
//                 <option value="Married">Married</option>
//                 <option value="Divorced">Divorced</option>
//                 <option value="Widowed">Widowed</option>
//               </Form.Select>
//             </Col>
//             <Col md={4}>
//               <Form.Label>Company</Form.Label>
//               <Form.Select
//                 name="company"
//                 value={formData.company}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Company</option>
//                 {companies.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.company_name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Department, Designation, Role */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Department *</Form.Label>
//               <Form.Select
//                 name="department"
//                 value={formData.department}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Department</option>
//                 {departments.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.department_name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label>Designation *</Form.Label>
//               <Form.Select
//                 name="designation"
//                 value={formData.designation}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Designation</option>
//                 {designations.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.designation_name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label>Role *</Form.Label>
//               <Form.Select
//                 name="role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 disabled
//               >
//                 <option value="">Select Role...</option>
//                 {roles.map((r) => (
//                   <option key={r} value={r}>
//                     {r}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Status, Office Shift, DOJ */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Status *</Form.Label>
//               <Form.Select
//                 name="status"
//                 value={formData.status}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Status...</option>
//                 {statuse.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label>Office Shift *</Form.Label>
//               <Form.Select
//                 name="officeShift"
//                 value={formData.officeShift}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Shift</option>
//                 {shifts.map((s) => (
//                   <option key={s.id} value={s.id}>
//                     {s.shift_name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label>Date Of Joining *</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dateOfJoining"
//                 value={formData.dateOfJoining}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>

//           {/* Date Of Leaving, Attendance Type */}
//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Label>Date Of Leaving</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dateOfLeaving"
//                 value={formData.dateOfLeaving}
//                 onChange={handleChange}
//               />
//             </Col>

//             <Col md={4}>
//               <Form.Label>Attendance Type *</Form.Label>
//               <Form.Select
//                 name="attendanceType"
//                 value={formData.attendanceType}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Type...</option>
//                 {attendanceTypes.map((a) => (
//                   <option key={a} value={a}>
//                     {a}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Save Button */}
//           <div className="text-end">
//             <Button variant="primary" onClick={handleSave}>
//               Save
//             </Button>
//           </div>
//         </Card>
//       </Col>
//     </Row>
//   );
// }

import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import api from "app/services/api";

export default function General({ employee, onUpdateSuccess }) {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [roles, setRoles] = useState([]);

  const statuses = ["Active", "Inactive", "Terminated"];
  const attendanceTypes = ["Daily", "In-Office", "Remote", "Hybrid"];

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    staffId: "",
    username: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    company: "",
    department: "",
    designation: "",
    role: "",
    status: "",
    officeShift: "",
    dateOfJoining: "",
    dateOfLeaving: "",
    attendanceType: "",
  });

  // ── Fetch helpers ──────────────────────────────────────────────
  const fetchCompanies = async () => {
    try {
      const res = await api.get("/api/company/all");
      setCompanies(res.data.data || []);
    } catch (e) {
      console.error("Companies fetch error:", e);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await api.get("/api/departments");
      setDepartments(res.data.departments || []);
    } catch (e) {
      console.error("Departments fetch error:", e);
    }
  };

  const fetchDesignations = async (departmentId) => {
    if (!departmentId) { setDesignations([]); return; }
    try {
      const res = await api.get(`/api/designations/all?department_id=${departmentId}`);
      setDesignations(res.data.data || []);
    } catch (e) {
      console.error("Designations fetch error:", e);
    }
  };

  const fetchShifts = async () => {
    try {
      const res = await api.get("/api/office-shifts");
      const data = Array.isArray(res.data) ? res.data : [];
      setShifts(data.map((s) => ({ id: s.id, shift_name: s.Shift })));
    } catch (e) {
      console.error("Shifts fetch error:", e);
    }
  };

  // 🔥 Fetch roles from API (not hardcoded)
  const fetchRoles = async () => {
    try {
      const res = await api.get("/api/roles/all");
      setRoles(res.data.data || []);
    } catch (e) {
      console.error("Roles fetch error:", e);
    }
  };

  // ── Populate form when employee prop changes ───────────────────
  // useEffect(() => {
  //   if (!employee) return;

  //   const loadData = async () => {
  //     await fetchCompanies();
  //     await fetchRoles();
  //     await fetchDepartments(employee.company_id);
  //     await fetchDesignations(employee.company_id, employee.department_id);
  //     await fetchShifts(employee.company_id);

  //     // 🔥 AFTER DATA LOAD → SET FORM
  //     setFormData({
  //       firstName: employee.first_name || "",
  //       lastName: employee.last_name || "",
  //       staffId: employee.staff_id || "",
  //       username: employee.username || "",
  //       email: employee.email || "",
  //       phone: employee.contact_no || "",
  //       company: employee.company_id || "",
  //       department: employee.department_id || "",
  //       designation: employee.designation_id || "",
  //       role: employee.role_users_id || "",
  //       state: employee.state || "",
  //       dob: employee.date_of_birth?.split("T")[0] || "",
  //       dateOfJoining: employee.joining_date?.split("T")[0] || "",
  //       attendanceType: employee.attendance_type || "",
  //     });
  //   };

  //   loadData();
  // }, [employee]);

  useEffect(() => {
    if (!employee) return;

    const loadData = async () => {
      await fetchCompanies();
      await fetchRoles();
      await fetchDepartments();
      await fetchDesignations(employee.department_id);
      await fetchShifts();

      setFormData({
        firstName: employee.first_name || "",
        lastName: employee.last_name || "",
        staffId: employee.staff_id || "",
        username: employee.username || "",
        email: employee.email || "",
        phone: employee.contact_no || "",
        address: employee.address || "",
        city: employee.city || "",
        zip: employee.zip_code || "",
        country: employee.country || "",
        maritalStatus: employee.marital_status || "",
        company: employee.company_id?.toString() || "",
        department: employee.department_id?.toString() || "",
        designation: employee.designation_id?.toString() || "",
        role: employee.role_users_id?.toString() || "",
        state: employee.state || "",
        dob: employee.date_of_birth?.split("T")[0] || "",
        dateOfJoining: employee.joining_date?.split("T")[0] || "",
        dateOfLeaving: employee.exit_date?.split("T")[0] || "",
        gender: employee.gender || "",
        officeShift: employee.office_shift_id?.toString() || "",
        status:
          employee.is_active === 1
            ? "Active"
            : employee.is_active === 0
              ? "Inactive"
              : "",
        attendanceType: employee.attendance_type?.trim() || "",
      });
    };

    loadData();
  }, [employee]);
  // ── Handle field changes + cascading dropdowns ─────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "company") {
      setFormData((prev) => ({
        ...prev,
        department: "",
        designation: "",
        officeShift: "",
      }));
    }

    if (name === "department") {
      setFormData((prev) => ({ ...prev, designation: "" }));
      fetchDesignations(value);
    }
  };

  // ── Save ───────────────────────────────────────────────────────
  const handleSave = async () => {
    try {
      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        staff_id: formData.staffId,
        username: formData.username,
        email: formData.email,
        contact_no: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip_code: formData.zip,
        country: formData.country,
        date_of_birth: formData.dob || null,
        gender: formData.gender || null,
        marital_status: formData.maritalStatus || null,
        company_id: formData.company || null,
        department_id: formData.department || null,
        designation_id: formData.designation || null,
        role_users_id: formData.role || null,
        is_active:
          formData.status === "Active"
            ? 1
            : formData.status === "Inactive"
              ? 0
              : null,
        office_shift_id: formData.officeShift || null,
        joining_date: formData.dateOfJoining || null,
        exit_date: formData.dateOfLeaving || null,
        attendance_type: formData.attendanceType || null,
      };

      await api.put(`/api/employees/${employee.id}`, payload);
      alert("Employee data saved successfully!");

      // ✅ Trigger parent callback to refresh employee data
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Failed to save. Check console.");
    }
  };

  // ── UI ─────────────────────────────────────────────────────────
  return (
    <Row>
      <Col md={12}>
        <Card body>
          <h5 className="mb-3">Basic Information</h5>

          {/* Name & Staff ID */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Staff ID</Form.Label>
              <Form.Control
                name="staffId"
                value={formData.staffId}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Username, Email, Phone */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Username</Form.Label>
              <Form.Control
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Email</Form.Label>
              <Form.Control
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Address, City, State */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>City</Form.Label>
              <Form.Control
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>State / Province</Form.Label>
              <Form.Control
                name="state"
                value={formData.state}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Zip, Country, DOB */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Zip</Form.Label>
              <Form.Control
                name="zip"
                value={formData.zip}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Country</Form.Label>
              <Form.Select
                name="country"
                value={formData.country}
                onChange={handleChange}
              >
                <option value="">Select Country</option>
                <option value="India">India</option>
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Canada">Canada</option>
                <option value="Australia">Australia</option>
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Date Of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Gender, Marital Status, Company */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Gender</Form.Label>
              <Form.Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Marital Status</Form.Label>
              <Form.Select
                name="maritalStatus"
                value={formData.maritalStatus}
                onChange={handleChange}
              >
                <option value="">Select Marital Status</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Company</Form.Label>
              <Form.Select
                name="company"
                value={formData.company}
                onChange={handleChange}
              >
                <option value="">Select Company</option>
                {companies.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.company_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {/* Department, Designation, Role */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Department *</Form.Label>
              <Form.Select
                name="department"
                value={formData.department}
                onChange={handleChange}
              >
                <option value="">Select Department</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.department_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Designation *</Form.Label>
              <Form.Select
                name="designation"
                value={formData.designation}
                onChange={handleChange}
              >
                <option value="">Select Designation</option>
                {designations.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.designation_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              {/* 🔥 Role now fetched from API with IDs */}
              <Form.Label>Role *</Form.Label>
              <Form.Select
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                <option value="">Select Role</option>
                {roles.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {/* Status, Office Shift, DOJ */}
          <Row className="mb-3">
            <Col md={4}>
              {/* 🔥 Status derived from is_active */}
              <Form.Label>Status *</Form.Label>
              <Form.Select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                {statuses.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Office Shift *</Form.Label>
              <Form.Select
                name="officeShift"
                value={formData.officeShift}
                onChange={handleChange}
              >
                <option value="">Select Shift</option>
                {shifts.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.shift_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Date Of Joining *</Form.Label>
              <Form.Control
                type="date"
                name="dateOfJoining"
                value={formData.dateOfJoining}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Date Of Leaving, Attendance Type */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label>Date Of Leaving</Form.Label>
              <Form.Control
                type="date"
                name="dateOfLeaving"
                value={formData.dateOfLeaving}
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              {/* 🔥 Attendance type includes "Daily" to match DB value */}
              <Form.Label>Attendance Type *</Form.Label>
              <Form.Select
                name="attendanceType"
                value={formData.attendanceType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                {attendanceTypes.map((a) => (
                  <option key={a} value={a}>
                    {a}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {/* Save Button */}
          <div className="text-end">
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </Card>
      </Col>
    </Row>
  );
}
